import { useEffect, useRef } from 'react';

type RevealVariant = 'fade-up' | 'fade-left' | 'fade-right' | 'scale';

const variantClasses: Record<RevealVariant, string> = {
  'fade-up': 'reveal-fade-up',
  'fade-left': 'reveal-fade-left',
  'fade-right': 'reveal-fade-right',
  'scale': 'reveal-scale',
};

export function useScrollReveal<T extends HTMLElement>(threshold = 0.12, variant: RevealVariant = 'fade-up') {
  const ref = useRef<T>(null);
  const variantClass = variantClasses[variant];

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    el.classList.add(variantClass);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, variantClass]);

  return ref;
}